<script setup lang="ts">
import { computed } from 'vue'
import { useTheme } from 'vuetify'
import logoWhite from '../../assets/images/logoWhite.png'
import logoDark from '../../assets/images/logoDark.png'

const theme = useTheme()

const logoSrc = computed(() => logoWhite)
// const logoSrc = computed(() =>
//   theme.global.current.value.dark ? logoWhite : logoDark,
// )
</script>

<template>
  <img :src="logoSrc" width="160" alt="Logo">
</template>
